import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
let scriptPromise;
const loadTurnstile = () => {
  if (window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const timeout = setTimeout(() => fail(), 15000);
    const fail = () => {
      clearTimeout(timeout);
      script.remove();
      scriptPromise = undefined;
      reject(new Error('Falha ao carregar verificação de segurança'));
    };
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = () => {
      clearTimeout(timeout);
      if (window.turnstile) resolve();else fail();
    };
    script.onerror = fail;
    document.head.appendChild(script);
  });
  return scriptPromise;
};
const TurnstileWidget = forwardRef(({
  siteKey,
  onVerify,
  onExpire,
  onError,
  theme = 'light',
  size = 'normal',
  className = ''
}, ref) => {
  const [attempt, setAttempt] = useState(0);
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onVerifyRef = useRef(onVerify);
  const onExpireRef = useRef(onExpire);
  const onErrorRef = useRef(onError);
  useEffect(() => {
    onVerifyRef.current = onVerify;
    onExpireRef.current = onExpire;
    onErrorRef.current = onError;
  }, [onVerify, onExpire, onError]);
  useImperativeHandle(ref, () => ({
    reset: () => {
      onExpireRef.current?.();
      if (widgetIdRef.current === null) setAttempt(value => value + 1);
      if (widgetIdRef.current !== null && window.turnstile) {
        try {
          window.turnstile.reset(widgetIdRef.current);
        } catch {
          onErrorRef.current?.();
        }
      }
    }
  }), []);
  useEffect(() => {
    let cancelled = false;
    const initializeWidget = async () => {
      try {
        if (!siteKey) throw new Error('Verificação indisponível');
        await loadTurnstile();
        if (cancelled) return;
        widgetIdRef.current = window.turnstile.render(containerRef.current, {
          sitekey: siteKey,
          theme,
          size,
          callback: token => onVerifyRef.current?.(token),
          'expired-callback': () => onExpireRef.current?.(),
          'error-callback': () => onErrorRef.current?.(),
          'timeout-callback': () => onErrorRef.current?.(),
          'refresh-expired': 'auto',
          'refresh-timeout': 'auto'
        });
      } catch {
        if (!cancelled) onErrorRef.current?.();
      }
    };
    initializeWidget();
    return () => {
      cancelled = true;
      if (widgetIdRef.current !== null && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch {
          // The provider may already have removed the widget.
        }
        widgetIdRef.current = null;
      }
    };
  }, [siteKey, theme, size, attempt]);
  return <div ref={containerRef} className={className} />;
});
TurnstileWidget.displayName = 'TurnstileWidget';
export default TurnstileWidget;
